// libs
import styled, { css } from 'styled-components'
// themes
import { colors } from 'themes'
// components
import { DialogTitle } from '@mui/material'
import { Collapse as CollapseOrigin, Scrollbar } from 'components/UI'
import { FloatingBottomPaper } from 'components/FormElements/FloatingActions/views'
import { Scrollbar as ActivitiesScrollbar } from 'components/Modals/PlanItems/components/ActivitiesList/components/ActivitiesContent'
// static
import OpenIconOrigin from '@mui/icons-material/OpenInFull'
import CollapseIconOrigin from '@mui/icons-material/CloseFullscreen'
// constants
import { FULL_MODAL_PLAN_SUB_ENTITY_WIDTH } from 'constants/layout'
// utils
import { ellipsis, size } from 'polished'

export const Header = styled(DialogTitle)`
  && {
    display: flex;
    align-items: center;
    color: ${colors.white100};
    font-size: 22px;
    font-weight: bold;
    position: relative;
    background: ${colors.darkBlue500};
    height: 64px;
    padding-top: 20px;

    & > span {
      ${ellipsis('90%')};
    }
  }
`

export const OpenIcon = styled(OpenIconOrigin)`
  && {
    position: absolute;
    right: 50px;
    top: 50%;
    transform: translateY(-50%);
    cursor: pointer;
    ${size('18px')};
  }
`

export const Wrapper = styled(Scrollbar)`
  height: 100%;
  width: 100%;
`

export const SubHeader = styled.div`
  position: relative;

  svg {
    top: 24px !important;
  }
`

export const ContentWrapper = styled.div`
  display: flex;
  flex: 1;
  height: calc(100% - 64px);
  width: 100%;
`

export const FormWrapper = styled.div`
  position: relative;
  max-height: 100%;
  width: ${FULL_MODAL_PLAN_SUB_ENTITY_WIDTH}px;
  border-right: 2px solid ${colors.darkBlue500};
`

export const DetailsWrapper = styled.div`
  width: calc(100% - ${FULL_MODAL_PLAN_SUB_ENTITY_WIDTH}px);
  height: calc(100vh - 115px);
`

export const Collapse = styled(CollapseOrigin)`
  padding: 16px 0;
  margin: 0;
`

export const CollapseIcon = styled(CollapseIconOrigin)`
  && {
    position: absolute;
    right: 50px;
    top: 50%;
    transform: translateY(-50%);
    cursor: pointer;
    ${size('18px')};
  }
`

export const FullModalHeader = styled(DialogTitle)`
  && {
    background: ${colors.darkBlue500};
    color: ${colors.white100};
    font-size: 22px;
    font-weight: bold;
    position: relative;
    height: 64px;
    padding-top: 20px;
  }
`

export const DetailsSectionWrapper = styled.div<{
  $isFullModal?: boolean
  $shouldShowModalActions?: boolean
}>`
  padding: 0 16px;
  overflow-x: hidden;

  ${({ $shouldShowModalActions }) =>
    $shouldShowModalActions &&
    css`
      margin-bottom: 56px;
    `};

  ${FloatingBottomPaper} {
    width: 600px;
    right: 0;

    ${({ $isFullModal }) =>
      $isFullModal &&
      css`
        left: 0;
        right: unset;
        width: 100%;
      `}
  }
`

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 16px;
`

export const ActivitiesWrapper = styled('div')`
  height: 100%;

  > div {
    height: 100%;
  }

  ${ActivitiesScrollbar} {
    height: calc(100% - 108px);
  }
`
